import { connect } from "react-redux";
import { getShowSolved } from "../../reducers/ui/selectors";
import {
  getNextLevel,
  getNextSeed,
  getPrizes
} from "../../reducers/crossword/selectors";
import { toggleSolved } from "../../reducers/ui/actions";
import { setNextLevel, setNextSeed } from "../../reducers/crossword/uriActions";

import Solved from "./Solved";

const mapStateToProps = state => ({
  show: getShowSolved(state),
  level: getNextLevel(state),
  seed: getNextSeed(state),
  prizes: getPrizes(state)
});

const mapDispatchToProps = dispatch => ({
  hideSolved: () => dispatch(toggleSolved(false)),
  nextSeed: () => dispatch(setNextSeed()),
  nextLevel: () => dispatch(setNextLevel())
});

export default connect(mapStateToProps, mapDispatchToProps)(Solved);



// WEBPACK FOOTER //
// ./src/components/Solved/SolvedContainer.js